<template>
    <t-form-select
        :class="{ 'has-selection': month !== null }"
        :id="id"
        :name="name"
        :options="options"
        :value="month"
        @change="updateValue"
        class="jgile-month-picker"
    >
    </t-form-select>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        name: {
            type: String,
            default: 'month',
        },
        placeholder: {
            type: String,
            default: '-- Please select an option --',
        },
        id: {
            type: String,
            default: null,
        },
        value: {},
    },
    data() {
        return {
            month: null,
        };
    },
    computed: {
        options() {
            return _.reduce(
                moment.months(),
                (months, month, key) => {
                    months[key + 1] = month;
                    return months;
                },
                {},
            );
        },
    },
    methods: {
        updateValue(newVal) {
            this.$emit('input', newVal);
            if (this.id) {
                Bus.$emit('jgileMonthPicker', {
                    monthPicker: this.id,
                    value: newVal,
                });
            }
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                this.month = newVal;
            },
        },
    },
};
</script>
